module.exports = __webpack_public_path__ + "img/bottom_tube_001_1.f4d145b1.svg";